import { createSelector } from 'reselect';

export const selectWhitelabelConfig = org => org.whitelabelConfig;

export const selectBrandCreditSelfServiceDisabled = createSelector(
  selectWhitelabelConfig,
  config => config?.disableBrandCreditSelfService ?? false
);
